import { getMenu } from '@/clients/pops/client'
import { Menu } from '@/models/menu'
import dayjs, { type Dayjs } from '@/utilities/dayjs-config'

import { getKitchenIdByZip } from '../delivery-zone/operations'
import { $menus, $promises } from './stores'

export const loadMenu = async ({
  week,
  zip,
  force = false,
}: {
  week: Dayjs
  zip: string
  force?: boolean
}) => {
  const startOfWeek = dayjs(week).startOf('week')
  const menuKey = `${startOfWeek.format('YYYY-MM-DD')}${zip}`
  const promiseKey = `loadMenu${menuKey}`

  if ($promises.get()[promiseKey] && !force) {
    return $promises.get()[promiseKey]
  }

  const promise = (async () => {
    const kitchenId = (await getKitchenIdByZip(zip)) as string
    const menu = await getMenu(startOfWeek, kitchenId, zip)

    $menus.setKey(menuKey, new Menu(startOfWeek, menu))
  })()

  $promises.setKey(promiseKey, promise)

  return promise
}
